import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import * as fromCredentials from '../credentials/reducers';
import {map, tap} from 'rxjs/operators';
import {Credentials} from '@farmnet/webapp-loader-companion';


@Injectable({
  providedIn: 'root'
})
export class LoaderRedirectGuard implements CanActivate {

  constructor(
    private store: Store<fromRoot.State>,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.isDevMode().pipe(
      tap(isDev => {
        if (!isDev) {
          const pathSegments = route.pathFromRoot
            .slice(1)
            .reduce((acc: string[], r) => [...acc, ...r.url.map(segment => segment.path)], [])
            .filter(Boolean);

          const path = pathSegments.join('/') || '';

          const isAlreadyLoaderUrl = path.includes('loader');
          const loaderUrl = path ? `/loader/${path}` : '/loader/overview';

          if (!isAlreadyLoaderUrl) {
            window.location.href = loaderUrl;
          }
        }
      }),
      map(isDev => isDev) // still return false to block
    );
  }

  private isDevMode(): Observable<boolean> {
    return this.store.pipe(select(fromCredentials.getCredentials)).pipe(
      map((credentials: Credentials) => {
        return credentials?.cfn365site === 'dev';
      })
    );
  }
}
